import type { ComponentType } from 'react'
import AgencyHome from './AgencyHome'
import MultiStepForm from './MultiStepForm'
import SearchResults from './SearchResults'
import ServiceLanding from './ServiceLanding'
import type { TemplateId, TemplateProps } from './types'

export const templateComponents: Record<TemplateId, ComponentType<TemplateProps>> = {
  'agency-home': AgencyHome,
  'service-landing': ServiceLanding,
  'multi-step-form': MultiStepForm,
  'search-results': SearchResults,
}
